import { AbstractControl, ValidationErrors } from '@angular/forms';

export function differentPasswordValidator(control: AbstractControl): ValidationErrors | null {
  const actualPassword = control.get('actualPassword')?.value as string;
  const newPassword = control.get('password')?.value as string;

  if (actualPassword && newPassword && actualPassword === newPassword) {
    control.get('password')?.setErrors({incorrect: true});
  } else {
    control.get('password')?.setErrors(null);
  }
  return null;
}
